import { Component, OnInit, ViewChild } from '@angular/core';
import { Channel, ChannelsGroup, IPTVEditorComponent } from './includes/IPTV_Editor/iptv_editor.component';
import { Ajax } from './services/ajax.service';
import { DialogService } from './includes/dynamic_components/dialog/dialog.service';
import { DynamicComponentService } from './includes/dynamic_components/dynamic.service';
import { IPTVChannelComponent } from "./iptv.channel.component";
import { TextEditorComponent } from './text-editor.component';
import { StoreService } from './services/store.service';
import { EPG_Send_Data, EPG_list } from './includes/iptv-epg/epg.interfaces';
import { UploadFormComponent } from './upload.form.component';
import { IPTVVideoService } from './includes/iptv-video/iptv-video.service';
import { EpgWindowService } from './includes/iptv-epg/epg_window.service';
import { of, Subscription } from 'rxjs';
import { HelpComponent } from './help.component';
import { DemoMessageComponent } from './demo-message.component';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  channelsBundle:ChannelsBundle = {channels: [], groups: [], groupSelected: {id: 1, name: "Dummy"}, EXTGRP: true, EXTM3U_prop: ""};
  /**
   * Имя хранимого поля в LocalStorage
   */
  readonly storeNameItem:string = "channelsBundle";
  /**
   * Ajax загрущик текущей программы передач
   */
  _$ajax_epg_current:Subscription = null;
  /**
   * Время загрузки EPG для группы телеканалов.
   */
  private _time_download_epg:number = 0;
  /**
   * Дочерний компонент IPTVEditorComponent
   */
  @ViewChild(IPTVEditorComponent) private _iptvEditor:IPTVEditorComponent;

  constructor(private _ajax:Ajax, private _store:StoreService, private _dialog:DialogService, private _DCService:DynamicComponentService,
              private _player:IPTVVideoService, private _EPGservice:EpgWindowService){
    // Запрет перезагрузки страницы.
    window.addEventListener("beforeunload", function (e) {
      var confirmationMessage = "\o/";
    
      e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
      return confirmationMessage;              // Gecko, WebKit, Chrome <34
    });
    this._time_download_epg = Date.now();
  }
  ngOnInit(){
    const channelsBundle = this._store.get(this.storeNameItem);
    if(channelsBundle && "channels" in channelsBundle && "groups" in channelsBundle ){
      this.channelsBundle = <ChannelsBundle>channelsBundle;
      this.channelsBundle.groupSelected = this.channelsBundle.groups[0];

      this.epg_groups_get();
    } else {
      this.load_playlist();
    }

    // Периодически обновляем индикатор хронологии EPG канала и при необходимости меняем EPG
    setInterval(()=>{
      this.epg_current_update();
    }, 60 *1000);
    
  }
 
  /**
   * Загрузка плейлиста с сервера.
   */
  load_playlist(){
    // Строки кодировуем в Base64 чтобы было сложнее найти и подставить свой источник данных каналов.
    return this._ajax.send({op:atob("Z2V0X2NoYW5uZWxz")}, true, atob("Li4veHh4eHh4eHh4eC9qc29uX3NhbXBsZS94eHg")).subscribe((data)=>{
      this.channelsBundle.channels =data.channels;
      this.channelsBundle.groups = data.groups;
      this.channelsBundle.groupSelected = data.groups[0];
      this.epg_groups_get();
    });
  }
  /**
   * Скачивание файла playlist.m3u8
   * @param e 
   */
  download_file(e:MouseEvent){
    const playlist = new TextEditorComponent(this._dialog);
    playlist.channelsBundle = this.channelsBundle;
    playlist.sort = this.sort;
    playlist.init();
    (<HTMLAnchorElement>e.currentTarget).href = `data:text/m3u;charset=utf-8,` + encodeURIComponent(playlist.playlist);
  }
  /**
   * Загрузка собственного плейлиста.
   */
  upload(){
    const instance =  this._DCService.attach(UploadFormComponent);
    instance.loadedPlaylist.subscribe(playlist=>{
      const editor = this.open_text_editor();
      editor.playlist = playlist;
      editor.showJoinButton = true;
    });
  }
  /**
   * Открывает окно справки.
   */
  help(){
    const instance = this._DCService.attach(HelpComponent);
  }
  /**
  * Сортируем каналы исходя из очередности группы, для того чтобы каналы были верно отсортированы, по очередности группы.
  */
  sort (){
    const channels:Channel[] = [];
    this.channelsBundle.groups.forEach((group)=>{
        this.channelsBundle.channels.map((channel)=>{
            if(channel.group_id == group.id) channels.push(channel);
        });
    });
    this.channelsBundle.channels = channels;
  }
  /**
   * Изменение данных канала в окне формы
   * @param channel 
   */
  change_channel(channel:Channel) {
    const instance = this._DCService.attach(IPTVChannelComponent);
    instance.channel = channel;
    instance.onSubmit.subscribe(()=>{
      channel.epg = null;
      // Отключаем предыдущую загрузку, если она еще не была закончена
      if(this._$ajax_epg_current && !this._$ajax_epg_current.closed){
        this._$ajax_epg_current.unsubscribe();
      }
      const epg_data:EPG_Send_Data = {name: channel.name, epg_id:channel.tvg_id, client_id: this.channelsBundle.channels.indexOf(channel)};
      this.epg_get_current(new Array(epg_data));
    });
  }
  /**
   * Полное удаление канала из корзины.
   * @param channel Channel
   */
  remove_channel(channel:Channel) {
    this._dialog.confirm(`Удалить безвозвратно канал '${channel.name}' ?`, ok=>{
      if(ok === true){
        this._iptvEditor.channel_trash_remove(channel);
      }
    })
  }
  /**
   * Очистка корзины
   */
  empty_trash_event(){
    this._dialog.confirm("Вы действительно хотите очистить корзину?", (ok)=>{
      if(ok === true) this._iptvEditor.empty_trash();
    })
  }
  /**
   * Воспроизведение канала
   * @param channel 
   */
  play_channel(channel:Channel) {
    if(channel.url.search("iptv.ya.ru") == -1){
      this._player.channel = channel;
      this._player.play();
    } else {
      const instance = this._DCService.attach(DemoMessageComponent);
      
    }
  }
  /**
   * Переименование группы
   * @param group ChannelsGroup
   */
  change_group(group:ChannelsGroup) {
    this._dialog.prompt("Название группы", group.name, (value:string)=>{
      group.name = value;
      return true;
    });
  }
  /**
   * Выделеные группы каналов для отображения.
   * @param group 
   */
  selected_group(group:ChannelsGroup) {
    this.channelsBundle.groupSelected = group;
    if(!group.epg){
      this.epg_groups_get();
    }
  }
  /**
   * Удаление группы каналов
   * @param group Группа каналов
   */
  remove_group(group:ChannelsGroup){
    this._dialog.confirm(`Удалить группу "${group.name}"?`, ok=>{
      if(ok === true){
        this._iptvEditor.group_remove(group);
      }
    })
  }
  /**
   * Кнопка открытия текстового редактора
   */
  open_text_editor():TextEditorComponent{
    const instance = this._DCService.attach(TextEditorComponent);
    instance.channelsBundle = this.channelsBundle;
    instance.sort = this.sort;
    instance.init();
    instance.showJoinButton = false;
    instance.destroyEmitter.subscribe(null, null, ()=>{
      this.epg_groups_get();
    });
    return instance;
  }
  /**
   * Сохраняет плейлист в браузере.
   */
  store_playlist(){
    this._dialog.confirm("Cохранить плейлист в вашем браузере?", (ok)=>{
      if(ok){
        this.sort();
        // Удаляем EPG для каналов
        const copy = JSON.parse(JSON.stringify(this.channelsBundle));
        copy.channels.forEach((channel:Channel)=>{
          channel.epg = null;
        });
        // Удаляем индикатор загрузки EPG для групп
        copy.groups.forEach((group:ChannelsGroup)=>{
          group.epg = false;
        })
        if(this._store.save(copy, this.storeNameItem)){
          this._dialog.alert("Плейлист успешно сохранен в вашем браузере!");
        } else {
          this._dialog.alert("К сожалению плейлист не удалось сохранить в вашем браузере!");
        }
      }
    })

  }
  /**
   * Удаляет сохраненный плейлист и загружает плейлист с сервера.
   */
  restore_playlist(){
    this._dialog.confirm("Загрузить плейлист по умолчанию?", (ok)=>{
      if(ok){
        this._store.remove(this.storeNameItem);
        this.load_playlist().add(()=>{
          this._dialog.alert("Плейлист установлен по умолчанию!");
        });
      }
    });
  }
  /**
   * Загрузка EPG для каналов выделенной группы, на сегодня.
   */
  epg_groups_get(){
    if(this.channelsBundle.channels.length){
      let epg_data = new Array();
      this.channelsBundle.channels.forEach((channel, index)=>{
        if(channel.group_id == this.channelsBundle.groupSelected.id){
          epg_data.push({client_id:index, epg_id: channel.tvg_id, name: channel.name});
        }
      });
      this.epg_get_current(epg_data.slice(0,500));
      this.channelsBundle.groupSelected.epg = true;
    }
  }
  /**
   * Загружает EPG для указанного списка каналов. Фильтруются каналы, для которых EPG еще не загружался.
   * @param channels 
   */
  epg_channels_get(channels:Channel[]){
    if(channels.length){
      let epg_data = new Array();
      this.channelsBundle.channels.forEach((channel, index)=>{
        if(channels.indexOf(channel) >= 0 && !channel.epg){
          epg_data.push({client_id:index, epg_id: channel.tvg_id, name: channel.name});
        }
      });
      this.epg_get_current(epg_data.slice(0,500));
    }
  }
  /**
   * Загружает программу передач для указанных каналов, на текущий момент.
   * @param epg_data 
   */
  private epg_get_current(epg_data:EPG_Send_Data[]){
    if(epg_data.length){
      const ajax =  this._ajax.send({op:"get_epg_current", epg_data: JSON.stringify(epg_data)},false).subscribe(data=>{
        if(data.epg && data.epg.length) {
          data.epg.forEach((epg) => {
            const channel = this.channelsBundle.channels[parseInt(epg.client_id)];
            if(channel){
              if(!channel.tvg_id && epg.epg_id){
                channel.tvg_id = epg.epg_id;
              }
              if(!channel.icon && epg.icon){
                channel.icon = epg.icon;
              }
              if(epg.epg_json){
                const epg_list:EPG_list[] = JSON.parse(epg.epg_json);
                if(epg_list && epg_list.length){
                  epg_list.forEach((element:EPG_list, index:number) => {
                    element.start = Math.floor(element.start);
                    element.stop = epg_list[index+1] ? epg_list[index+1].start : element.stop;
                    element.stop = Math.floor(element.stop);
                    element.progress = 0;
                    if(index === 0) {
                      element.progress = (((Date.now()/1000)-element.start)/(element.stop-element.start))*100;
                      element.progress = element.progress < 0 ? 0 : element.progress;
                      element.progress = element.progress > 100 ? 100 : element.progress;
                    }
                  });
                  epg_list[0].chronology = "current";
                  channel.epg = epg_list;
                }
              }
            }
          });
        }
      },()=>{}, ()=>{
        const epg = this._EPGservice.get_empty_epg_current();
        epg_data.forEach(item=>{
          const channel = this.channelsBundle.channels[parseInt(item.client_id.toString())];
          if(channel && !channel.epg){
            // Создаем новый объект, а не присваиваем ссылку на epg
            channel.epg =  [Object.assign({},epg)];
          }
        });
        return epg_data;
      });
      /**
       * Если запрашивается EPG только на одному программу, происходит при изменении канала, то записываем в свойство, чтобы при следующем включении отменить загрузку.
       */
      if(epg_data.length == 1){
        this._$ajax_epg_current = ajax;
      }
      return ajax;
    } else {
      return of(false).subscribe();
    }
  }
  /**
   * Обновляет хронологию текущей передачи, если закончилась, то подставляет следующую
   */
  private epg_current_update(){
    const now = Math.floor(Date.now()/1000);
    // Каждые 2 часа обновляем программу передач для группы телеканалов.
    if((now*1000 - this._time_download_epg) > 2*60*60*1000){
      this._time_download_epg = now*1000;
      this.channelsBundle.groups.forEach(group=>{
        group.epg = null;
      });
      console.log("Обновляем EPG для текущей группы телеканалов", new Date()); 
      this.epg_groups_get();
    } else {
      this.channelsBundle.channels.forEach(channel=>{
        let epg:EPG_list = null
        if(channel.epg instanceof Array){
          channel.epg.findIndex((item,index)=>{
            if(item.stop >= now){ 
              epg = item;
              if(index > 0){
                channel.epg = channel.epg.slice(index, channel.epg.length-1);
              }
              return true;
            }
            return false;
          });
  
          if(!epg){// Если следующей телепередачи нет, то создаем пустую. Если заканчиваются передачи в channel.epg, после длительного простоя приложения, массив становится пустым.
            epg = this._EPGservice.get_empty_epg_current();
            channel.epg = [epg];
          }
          let progress = ((now - epg.start)/(epg.stop - epg.start))*100;
          progress = progress < 0 ? 0 : progress;
          progress = progress > 100 ? 100 : progress;
          epg.progress = progress;
          epg.chronology = "current";
        }
      });
    }
  }
  /**
   * Программа передач на день
   * @param channel Channel
   */
  epg_day_channel(channel:Channel){
    this._EPGservice.show(channel);
  }
}

/**
 * Каналы и группы храним в одном объекте, чтобы в текстовом редакторе, можно было манипулировать этими массивами.
 */
export interface ChannelsBundle {
  channels: Channel[], 
  groups: ChannelsGroup[], 
  groupSelected: ChannelsGroup, 
  /**
   * Флаг указывающий, что группы в плейлисте указаны в формате - #EXTGRP:новости Иначе в формате #EXTINF:-1 group-title="Русские"
   */
  EXTGRP: boolean, 
  /**
   * Все свойства которые идут после #EXTM3U 
   */
  EXTM3U_prop: string
}

    /* Добавляем ссылку на сайт под блоком групп
    setTimeout(function() {
      var addElement = document.querySelector("iptv-editor .channels .add");
      if(addElement){
        var hostLogo = document.createElement("b");
        hostLogo.innerText = "Nasharu.TV"
        hostLogo.style = `position: absolute;
        display: block;
        right: 3px;
        bottom: 0;
        color: #06a8e6;
        font-size: 10px;
        line-height: 14px;
        font-family: Verdana, serif;
        text-shadow: rgb(4 24 106) 0px 0px 2px;
        font-style: italic;`;
        addElement.appendChild(hostLogo);
      }
    }, 5000);

    setTimeout(function() {
      var addElement = document.querySelector(atob("aXB0di1lZGl0b3IgLmNoYW5uZWxzIC5hZGQ"));
      if(addElement){
        var hostLogo = document.createElement("b");
        hostLogo.innerText = atob("TmFzaGFydS5UVg");
        hostLogo.style = atob('cG9zaXRpb246IGFic29sdXRlOw0KICAgICAgICBkaXNwbGF5OiBibG9jazsNCiAgICAgICAgcmlnaHQ6IDNweDsNCiAgICAgICAgYm90dG9tOiAwOw0KICAgICAgICBjb2xvcjogIzA2YThlNjsNCiAgICAgICAgZm9udC1zaXplOiAxMHB4Ow0KICAgICAgICBsaW5lLWhlaWdodDogMTRweDsNCiAgICAgICAgZm9udC1mYW1pbHk6IFZlcmRhbmEsIHNlcmlmOw0KICAgICAgICB0ZXh0LXNoYWRvdzogcmdiKDQgMjQgMTA2KSAwcHggMHB4IDJweDsNCiAgICAgICAgZm9udC1zdHlsZTogaXRhbGljOw');
        addElement.appendChild(hostLogo);
      }
    }, 5000);
    */

    // @ts-ignore Отключает Type Checking только для следующей строки кода. Код кодируется здесь https://obfuscator.io/
    var _0x417b=['4osrQtx','382581RdxYel','300277VMmXbi','style','15121ufdcpS','29kTFzGN','1261SHnHlX','266587NGGYuk','TmFzaGFydS5UVg','1115656jgQfMA','3cQtgVu','635gDaPTe','createElement','1dbYvSc','511730GQXlNr','querySelector','innerText','1wUxAPp'];var _0x4d54=function(_0x4e15bf,_0x550b2c){_0x4e15bf=_0x4e15bf-0x11d;var _0x417bd2=_0x417b[_0x4e15bf];return _0x417bd2;};(function(_0x52e1a1,_0x2bd765){var _0x19f23c=_0x4d54;while(!![]){try{var _0x5a4c2d=parseInt(_0x19f23c(0x12a))*-parseInt(_0x19f23c(0x121))+parseInt(_0x19f23c(0x11d))*-parseInt(_0x19f23c(0x122))+-parseInt(_0x19f23c(0x12b))*parseInt(_0x19f23c(0x124))+parseInt(_0x19f23c(0x120))+-parseInt(_0x19f23c(0x12e))*parseInt(_0x19f23c(0x12d))+-parseInt(_0x19f23c(0x128))*-parseInt(_0x19f23c(0x11e))+-parseInt(_0x19f23c(0x129))*-parseInt(_0x19f23c(0x125));if(_0x5a4c2d===_0x2bd765)break;else _0x52e1a1['push'](_0x52e1a1['shift']());}catch(_0x2e5c23){_0x52e1a1['push'](_0x52e1a1['shift']());}}}(_0x417b,0xb520b),setTimeout(function(){var _0x2d94b6=_0x4d54,_0x266de4=document[_0x2d94b6(0x126)](atob('aXB0di1lZGl0b3IgLmNoYW5uZWxzIC5hZGQ'));if(_0x266de4){var _0x2284c6=document[_0x2d94b6(0x123)]('b');_0x2284c6[_0x2d94b6(0x127)]=atob(_0x2d94b6(0x11f)),_0x2284c6[_0x2d94b6(0x12c)]=atob('cG9zaXRpb246IGFic29sdXRlOw0KICAgICAgICBkaXNwbGF5OiBibG9jazsNCiAgICAgICAgcmlnaHQ6IDNweDsNCiAgICAgICAgYm90dG9tOiAwOw0KICAgICAgICBjb2xvcjogIzA2YThlNjsNCiAgICAgICAgZm9udC1zaXplOiAxMHB4Ow0KICAgICAgICBsaW5lLWhlaWdodDogMTRweDsNCiAgICAgICAgZm9udC1mYW1pbHk6IFZlcmRhbmEsIHNlcmlmOw0KICAgICAgICB0ZXh0LXNoYWRvdzogcmdiKDQgMjQgMTA2KSAwcHggMHB4IDJweDsNCiAgICAgICAgZm9udC1zdHlsZTogaXRhbGljOw'),_0x266de4['appendChild'](_0x2284c6);}},0x1388));